import { useFlags } from 'launchdarkly-react-client-sdk';

import { FUTRLI_MANAGEMENT_WORKSPACES } from '../report-builder/constants';
import { useRouteIds } from './useRouteIds';

/**
 * Futrli templates can only be created and managed from the Futrli management workspaces.
 * Uses the URL (not useParams) so it works from components rendered above the route context.
 */
export const useIsFutrliManagementWorkspace = () => {
  const flags = useFlags();
  const { workspaceId } = useRouteIds();

  return !!flags?.createReportTemplates && FUTRLI_MANAGEMENT_WORKSPACES.includes(workspaceId);
};
